const LISTRAK_STORAGE_KEY = 'ltk_accepts_cookies';

function saveToLocalStorage(value) {
  try {
    localStorage.setItem(LISTRAK_STORAGE_KEY, JSON.stringify(value));
  } catch (error) {
    console.warn(error);
  }
}

function getFromLocalStorage() {
  try {
    return JSON.parse(localStorage.getItem(LISTRAK_STORAGE_KEY));
  } catch (error) {
    console.warn(error);
    return null;
  }
}

function OptanonWrapper() {
  let ltkCookieValue;
  // C0003 is the cookie category for "Functionality" in OneTrust
  // C0004 is the cookie category for "Targeting" in OneTrust
  // Ref: https://my.onetrust.com/s/article/UUID-8102e851-d860-d465-d8d6-b1d636d68eb9?language=en_US
  if (OnetrustActiveGroups.includes('C0004')) {
    ltkCookieValue = true;
  } else {
    ltkCookieValue = false;
  }

  saveToLocalStorage(ltkCookieValue);
  const listrakBISForm = document.querySelector('bis-form-wrapper');
  const listrakWaitlistForm = document.querySelector('listrak-waitlist-form');

  if (OnetrustActiveGroups.includes('C0003')) {
    const technicalDataEl = document.querySelector('[data-technical]');
    if (!technicalDataEl) return;
    const data = JSON.parse(technicalDataEl.textContent);
    const listrakID = data['listrakId'] ?? null;
    loadListrak(ltkCookieValue, listrakID);

    if (listrakBISForm) {
      listrakBISForm.style.display = 'block';
    }
    if (listrakWaitlistForm) {
      listrakWaitlistForm.style.display = 'block';
    }
  } else {
    if (listrakBISForm) {
      listrakBISForm.style.display = 'none';
    }
    if (listrakWaitlistForm) {
      listrakWaitlistForm.style.display = 'none';
    }
  }
}

function loadListrak(value, listrakID) {
  if (!listrakID || listrakID == '' || value == undefined) return;
  var biJsHost = 'https:' == document.location.protocol ? 'https://' : 'http://';
  (function (d, s, id, tid, vid) {
    var js,
      ljs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = biJsHost + 'cdn.listrakbi.com/scripts/script.js?m=' + tid + '&v=' + vid;
    ljs.parentNode.insertBefore(js, ljs);
  })(document, 'script', 'ltkSDK', listrakID, '1');

  if (window._ltk) {
    _ltk.Session.setPersonalizedStatus(value);
  } else {
    setTimeout(() => {
      _ltk.Session.setPersonalizedStatus(value);
    }, 5000);
  }
}
